export function Invoice() {
  return (
    <h1 className="d-flex flex-row justify-content-center mt-3">
      <br /> <br /> Kommer snart
    </h1>
  );
}
